import React, { useState } from 'react';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';

const FlyoutContent = (props) => {
  return (
    <div>
      <TextInfo {...props.content} />
    </div>
  );
};

export default FlyoutContent;
